import React from "react";

export const Logo = ({ size = 44, className = "" }) => {
  return (
    <div
      className={`flex items-center ${className}`}
      data-testid="brand-logo"
    >
      <img
        src="/logo-192.png"
        alt="Pets · Perdidos e Achados"
        width={size}
        height={size}
        className="rounded-[22%] shadow-sm"
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default Logo;
